import React from 'react';
import GenericInternalTransfer from '../GenericInternalTransfer';

const AdminSectionInternalTransfer = () => (
  <GenericInternalTransfer
    sectionName="Admin Section"
    sectionKey="Admin Section"
    backRoute="/sections/admin-section"
  />
);

export default AdminSectionInternalTransfer;
